import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { APP_CONST } from '$app/constant';

(async () => {
  if (import.meta.env.MODE === 'test') return;

  i18n
    .use(initReactI18next)
    .use(HttpApi)
    .init({
      fallbackLng: APP_CONST.LANG.EN,
      backend: {
        loadPath: `${import.meta.env.BASE_URL}locales/{{lng}}/{{ns}}.json`,
      },
      defaultNS: 'translation',
      fallbackNS: 'translation',
      keySeparator: '.',
      ns: ['translation'],
      supportedLngs: Object.values(APP_CONST.LANG),
      interpolation: {
        escapeValue: false,
      },
    });

  await i18n.changeLanguage(
    navigator.language.replace(/-\w+/gi, '').toLowerCase(),
  );
})();

export default i18n;
